
<c-list-card
    :edit      = "false"
    :height    = "220"
    :drag-type = "dragData"
    :drag-data = "dragData"
    @dragend   = "onDragend ()"
>
    <template v-slot:title>
        <div class="v-flex " style="width: calc(100% - 30px)">
            <div class="cb-title">
                {{ entry.incidentId }} {{ entry.typeName }}
            </div>
            <v-spacer />
            <div class="text-right" style="width: 150px">
                {{ entry.unit.customer.name }}
            </div>
        </div>
        <div class="ml-1" style="margin-top: -4px">
            <c-toolbar-button
                icon     = "mdi-arrow-left"
                color    = "primary"
                size     = "20"
                :tooltip = "$t('clipboard.show.tooltip')"
                @click   = "onShow"
            />
        </div>
    </template>
    <template v-slot:subtitle>
        <div style="font-size: 14px">
            {{ $t('top.site.location', [ entry.unit.street, entry.unit.zip, entry.unit.city ]) }} - {{ entry.unit.fabricNo }}
        </div>

    </template>
    <template v-slot:body>
        <v-divider class="mt-2 mb-2" />
        <div
            v-for="step in entry.steps"
            :key = "step.id"
        >
            <div class="v-flex">
                <div
                    class="step-label white--text mt-1"
                    :class="step.valid ? 'success' : 'error'"
                >
                    {{ step.sequence }}
                </div>

                <div style="margin-left: 8px;margin-top: 2px;">
                    <div>
                        {{ step.name }}

                    </div>
                    <div style="font-size: 11px; margin-top: -6px; ">
                        {{ step.status }}
                    </div>
                </div>
            </div>
        </div>
    </template>
</c-list-card>
